import { defineMessages } from 'react-intl';

const translations = {
  feedback: {
    userInviteSent: {
      id: 'pages.users.feedback.userInviteSent',
      defaultMessage: 'Invitation has been sent',
      description: 'success feedback message of the user resent invite action',
    },
    userInviteNotSent: {
      id: 'pages.users.feedback.userInviteNotSent',
      defaultMessage: 'User invitation could not be sent',
      description: 'error feedback message of the user create invite action',
    },
    userInviteCancelled: {
      id: 'pages.users.feedback.userInviteCancelled',
      defaultMessage: 'Invitation has been cancelled',
      description: 'success feedback message of the user cancel invite action',
    },
    userInviteNotCancelled: {
      id: 'pages.users.feedback.userInviteNotCancelled',
      defaultMessage: 'User invitation could not be cancelled',
      description: 'error feedback message of the user cancel invite action',
    },
  },
  confirmCancelInvite: {
    title: {
      id: 'pages.users.confirmCancelInvite.title',
      defaultMessage: 'Revoke invite',
      description: 'title of the confirm revoke invite',
    },
    description: {
      id: 'pages.users.confirmCancelInvite.description',
      defaultMessage: 'Are you sure you want to revoke this invite?',
      description: 'description of the confirm revoke invite',
    },
    actions: {
      revoke: {
        id: 'pages.users.confirmCancelInvite.actions.revoke',
        defaultMessage: 'Revoke',
        description: 'label of the revoke invite button',
      },
      cancel: {
        id: 'pages.users.confirmCancelInvite.actions.cancel',
        defaultMessage: 'cancel',
        description: 'label of the cancel button',
      },
    },
  },
};

export default defineMessages(translations);
